'use client'

import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

import { MediaProps } from '../types'

import { getMediaUrl } from '@/utilities/getMediaUrl'
import { Media } from '@/payload-types'
import { useTranslations } from 'next-intl'

function isMedia(obj: unknown): obj is Media {
  return typeof obj === 'object' && obj !== null && 'url' in obj
}

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { onClick, resource, videoClassName, videoProps } = props

  const [isPlaying, setIsPlaying] = useState(false)
  const t = useTranslations()

  const videoRef = useRef<HTMLVideoElement>(null)
  // const [showFallback] = useState<boolean>()

  const handlePlay = () => {
    const video = videoRef.current
    if (!video) return

    if (video.paused) {
      video.play()
      setIsPlaying(true)
    } else {
      video.pause()
      setIsPlaying(false)
    }
  }

  useEffect(() => {
    const { current: video } = videoRef
    if (video) {
      video.addEventListener('suspend', () => {
        // setShowFallback(true);
        // console.warn('Video was suspended, rendering fallback image.')
      })
    }
  }, [])

  if (resource && typeof resource === 'object') {
    const { filename } = resource

    return (
      <div className="relative group w-full h-full">
        <video
          ref={videoRef}
          className={clsx('w-full h-full object-cover', videoClassName)}
          onClick={onClick}
          playsInline
          loop={videoProps?.loop}
          muted={videoProps?.muted}
          controls={isPlaying} // hide default controls
          autoPlay={videoProps?.autoplay}
          poster={
            isMedia(videoProps?.placeholderImage)
              ? getMediaUrl(videoProps.placeholderImage.url)
              : undefined
          }
        >
          <source src={getMediaUrl(`/api/media/file/${filename}`)} />
        </video>

        {!isPlaying && !videoProps?.autoplay && (
          <button
            onClick={handlePlay}
            aria-label={t('play_video')}
            className="bg-[#02061880] absolute inset-0 flex items-center justify-center max-w-fit max-h-fit m-auto rounded-full p-4"
          >
            <div className="bi bi-play-fill text-7xl text-primary"></div>
          </button>
        )}
      </div>
    )
  }

  return null
}
